import React from 'react';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';

export const ViewType = {
    Basic: 'basic',
    Margin: 'margin',
    Payments: 'payments',
    Full: 'full',
    All: 'all'
};

export const getViewSettings = (viewType) => {
    switch (viewType) {
        case ViewType.Basic:
            return {
                total_cost_usd: false,
                gross_product_margin: false,
                total_paid: false,
                balance: false,
                total_additional_costs: false,
                suppliers: false,
                shipper: false,
            };
        case ViewType.Margin:
            return {
                total_paid: false,
                total_additional_costs: false,
                balance: false,
                suppliers: false,
                shipper: false,
            };
        case ViewType.Payments:
            return {
                total_cost_usd: false,
                gross_product_margin: false,
                suppliers: false,
                shipper: false,
            };
        case ViewType.Full:
            return {
                // Show all columns
                total_cost_usd: true,
                gross_product_margin: true,
                total_paid: true,
                balance: true,
                total_additional_costs: true,
                suppliers: true,
                shipper: true,
            };
        case ViewType.All:
            return {}; // User-defined visibility
        default:
            console.warn(`Unknown view type: ${viewType}`);
            return {};
    }
};

const ViewControls = ({ viewType, onViewTypeChange }) => {
    const handleViewTypeChange = (type) => {
        onViewTypeChange(viewType === type ? ViewType.All : type);
    };

    return (
        <Stack
            direction="row"
            spacing={1}
            sx={{
                mb: 2,
                justifyContent: 'flex-end',
                alignItems: 'center'
            }}
        >
            <Typography variant="caption" sx={{ mr: 1 }}>
                Selected view:
            </Typography>
            {Object.values(ViewType).map((type) => (
                type !== ViewType.All && (
                    <Chip
                        key={type}
                        label={`${type.charAt(0).toUpperCase() + type.slice(1)}`}
                        color={viewType === type ? 'primary' : 'default'}
                        onClick={() => handleViewTypeChange(type)}
                        variant={viewType === type ? 'filled' : 'outlined'}
                    />
                )
            ))}
        </Stack>
    );
};

export default ViewControls;